import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Download } from "lucide-react";
import { FindoSpinner } from "@/components/FindoSpinner";

/** GDPR audit tool: download all dated data-sharing consents as CSV. */
export default function ConsentExportPanel() {
  const [busy, setBusy] = useState(false);

  async function download() {
    setBusy(true);
    try {
      const csv = await api("/admin/consents/export");
      const blob = new Blob([typeof csv === "string" ? csv : JSON.stringify(csv)], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "findloop-consentements-rgpd.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Export téléchargé");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="bg-white rounded-2xl border border-border card-shadow p-6 max-w-xl" data-testid="consent-export-panel">
      <div className="flex items-center gap-2.5 mb-1">
        <div className="h-9 w-9 grid place-items-center rounded-xl bg-emerald-500/10 text-emerald-600"><ShieldCheck size={18} /></div>
        <h3 className="font-display font-bold text-lg text-slate-900">Consentements RGPD</h3>
      </div>
      <p className="text-sm text-slate-500 mb-5">
        Exportez la preuve horodatée de tous les consentements de partage de coordonnées
        (déclarations partenaires + annonces publiques) au format CSV, pour vos audits RGPD.
        Chaque ligne inclut la date/heure et la version des conditions acceptées.
      </p>
      <Button onClick={download} disabled={busy} className="rounded-xl font-semibold" data-testid="consent-export-btn">
        {busy ? <FindoSpinner size={16} className="mr-1.5" /> : <Download size={16} className="mr-1.5" />}
        Exporter en CSV
      </Button>
    </div>
  );
}
